import { put, PutEffect, select, SelectEffect } from 'redux-saga/effects';

import { DeleteActiveElementsAction, deleteMultipleElementsById } from 'js/actionCreators/scribeActions';
import { ExistingScribeModel } from 'js/types';
import { showError } from 'js/actionCreators/uiActions';

import { getActiveElements, getScribeById } from '../selectors';

export function* deleteActiveElements({
  scribeId
}: DeleteActiveElementsAction): Generator<
  SelectEffect | PutEffect,
  void,
  (ExistingScribeModel | undefined) | string[]
> {
  const activeScribe = (yield select(getScribeById, scribeId)) as ExistingScribeModel | undefined;
  if (!activeScribe) {
    return;
  }

  const activeElements = (yield select(getActiveElements)) as string[];
  let displayNoDeleteMessage = false;
  const filteredElements = activeElements.filter(element => {
    if (activeScribe.scenes.some(scene => scene.elementIds[0] === element)) {
      displayNoDeleteMessage = true;
      return false;
    }
    return true;
  });

  if (displayNoDeleteMessage) {
    yield put(
      showError({
        message: "A scene's starting camera cannot be deleted or rearranged."
      })
    );
  }
  yield put(deleteMultipleElementsById(filteredElements, scribeId));
}
